import { render, staticRenderFns } from "./ProblemUserEdit.vue?vue&type=template&id=152ec49f&scoped=true"
import script from "./ProblemUserEdit.vue?vue&type=script&lang=js"
export * from "./ProblemUserEdit.vue?vue&type=script&lang=js"
import style0 from "./ProblemUserEdit.vue?vue&type=style&index=0&id=152ec49f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ec49f",
  null
  
)

export default component.exports